import { Platforms } from '../../enums';
import { useDevice, useInviteModal } from '../../hooks';
import { Button, Modal } from '../ui';
import './InviteModal.css';

export function InviteModal(props: { referralCode: string; username: string; isOpen: boolean; onClose: () => void }) {
   const { isOpen, onClose, username } = props;
   const { isMobile } = useDevice();
   const { hasCopiedLink, hasCopiedCode, referralLink, copyLink, copyCode, sendVia } = useInviteModal(props.referralCode, username);

   return (
      <Modal
         className="invite-modal "
         onClose={onClose}
         active={isOpen}
         darkBackground>
         <div className="flex flex-col gap-4 items-center">
            <div className="flex flex-col items-center gap-2">
               <img
                  src="/assets/icons/share-icon.png"
                  alt=""
                  className="share-icon"
                  width={isMobile ? 80 : 100}
               />
               <div className="flex flex-col items-center gap-2">
                  <h3>Invite friends to get more rewards</h3>
                  <span className="gray text-center w-80">Get consumable balls, giveaway entries & free membership tiers</span>
               </div>
            </div>

            <div className="box bg-gray-2 flex flex-col items-center gap-2">
               <span className="small">Referral link</span>
               <input
                  type="text"
                  className="referral-link-input green round"
                  disabled
                  value={referralLink}
               />
               <div className="flex gap-2 wrap">
                  <Button
                     type="white"
                     children={
                        <div className="flex items-center justify-center gap-2">
                           <span className="dark-gray">{hasCopiedLink ? 'Copied!' : 'Copy link'}</span>
                           <img
                              src="/assets/icons/copy-icon.svg"
                              alt=""
                              width={15}
                           />
                        </div>
                     }
                     onClick={copyLink}
                  />
                  <Button
                     type="white"
                     children={
                        <div className="flex items-center justify-center gap-2">
                           <span className="dark-gray">{hasCopiedCode ? 'Copied!' : 'Copy code'}</span>
                           <img
                              src="/assets/icons/copy-icon.svg"
                              alt=""
                              width={15}
                           />
                        </div>
                     }
                     onClick={copyCode}
                  />
               </div>
            </div>
            <div className="flex flex-col gap-3 justify-center">
               <span className="text-center">Send via:</span>
               <div className="flex items-center gap-3 wrap">
                  <Button
                     type="transparent"
                     children={
                        <div className="flex flex-col items-center gap-1">
                           <img
                              src="/assets/icons/message-icon.svg"
                              alt=""
                              width={40}
                           />
                           <span className="smaller">Message</span>
                        </div>
                     }
                     onClick={() => sendVia(Platforms.MESSAGE)}
                  />
                  <Button
                     type="transparent"
                     children={
                        <div className="flex flex-col items-center gap-1">
                           <img
                              src="/assets/icons/twitter-icon.svg"
                              alt=""
                              width={40}
                           />
                           <span className="smaller">X</span>
                        </div>
                     }
                     onClick={() => sendVia(Platforms.TWITTER)}
                  />
                  <Button
                     type="transparent"
                     children={
                        <div className="flex flex-col items-center gap-1">
                           <img
                              src="/assets/icons/telegram-icon.svg"
                              alt=""
                              width={40}
                           />
                           <span className="smaller">Telegram</span>
                        </div>
                     }
                     onClick={() => sendVia(Platforms.TELEGRAM)}
                  />
                  <Button
                     type="transparent"
                     children={
                        <div className="flex flex-col items-center gap-1">
                           <img
                              src="/assets/icons/whatsapp-icon.svg"
                              alt=""
                              width={40}
                           />
                           <span className="smaller">WhatsApp</span>
                        </div>
                     }
                     onClick={() => sendVia(Platforms.WHATSAPP)}
                  />
                  <Button
                     type="transparent"
                     children={
                        <div className="flex flex-col items-center gap-1">
                           <img
                              src="/assets/icons/more-icon.svg"
                              alt=""
                              width={40}
                           />
                           <span className="smaller">More</span>
                        </div>
                     }
                     onClick={() => sendVia(Platforms.MORE)}
                  />
               </div>
            </div>
         </div>
      </Modal>
   );
}
